import { createAction } from 'redux-actions';
import types from '../types';

export const openServicecaseModal = createAction(types.OPEN_MODAL);
export const closeServicecaseModal = createAction(types.CLOSE_MODAL);
export const createServicecase = createAction(types.CREATE_REQUESTED);
export const updateServicecase = createAction(types.UPDATE_REQUESTED);
export const editServicecase = createAction(types.EDIT_SERVICECASE);
